<div class="tables">
    <main class="content">
        <section class="header">
            <div class="top">
                <span>
                    <h1>Browse all labels</h1>
                </span>
            </div>
            <!-- CLASS "SL" IS FOR USERS WITH A SINGLE LABEL -->
            <div class="ac sl listtable">

                <div class="actions">
                    <input class="search" type="search" placeholder="Search for label..." [(ngModel)]="searchString"
                        (input)="searchChanged()" autofocus />
                
                    <!-- <div class="t-c" *ngIf="isAdmin"> 
                        <div class="toggle-row" >
                            <div class="toggle-switch">
                                <input type="checkbox" id="access-level" [(ngModel)]="showInactive">
                                <span class="ts"></span>
                            </div>
                            <label class="right" for="access-level">Show inactive</label>
                        </div>
                    </div>       -->
                    <!-- <figure *ngIf="isAdmin"></figure> -->
                    <button id="addlabel" class="btn green" *ngIf="isAdmin" (click)="openAddLabelModal()">Add new label</button>
                </div>

                <div class="list labellisttable superadmin">
                    <div class="dh">
                        <div>Name of label</div>
                        <div>Parent label</div>
                        <div>Created at</div>
                        <div>Actions</div>
                    </div>

                    <!-- Dynamic data rows from API -->
                    <div class="dr" *ngFor="let rightsholderBoard of rightsholders">
                        <ng-container *ngIf="rightsholderBoard.isActive !== false || (isAdmin && showInactive)">
                            <div>{{ rightsholderBoard.rightsholderName }}
                                <span class="tag green"
                                    *ngIf="!isAdmin && activeBoardId == rightsholderBoard.boardId">active</span>
                                    <span class="tag red"
                                    *ngIf="isAdmin &&  rightsholderBoard.isActive == false">Inactive</span>

                            </div>
                            <div>{{
                                (rightsholderBoard.parentRightsholderId === null || rightsholderBoard.parentRightsholderName
                                === "Music Nest Norway")
                                ? "None"
                                : (rightsholderBoard.parentRightsholderName || '-')
                                }}</div>
                            <div>{{ rightsholderBoard.createdAt | date: 'd/M yyyy' }}</div>
                            <div class="options">
                                <button class="btn white"
                                    (click)="navigateToSettings(rightsholderBoard.boardId, rightsholderBoard.rightsholderName)">Settings</button>
                                <button class="btn green" *ngIf="!isAdmin && activeBoardId !== rightsholderBoard.boardId"
                                    (click)="switchLabel(rightsholderBoard.boardId)">Set as active label</button>
                                <!-- <div class="btn white submenu" *ngIf="isAdmin"
                                    [ngClass]="{'show': activeSubmenuId === rightsholderBoard.boardId}"
                                    (click)="toggleSubmenu(rightsholderBoard.boardId, $event)">
                                    <div class="trigger" (click)="toggleSubmenu(rightsholderBoard.boardId, $event)">
                                        <img src="/assets/icons/three-dots-vertical.svg" alt="submenu" />
                                    </div>
                                    <div class="subitems">
                                        <a href="#"
                                            (click)="openDeleteDialog(rightsholderBoard.boardId); $event.preventDefault()">Delete
                                            label</a>
                                    </div>
                                </div> -->
                            </div>
                        </ng-container>
                    </div>

                    <!-- Show message when no results found -->
                    <div class="dr" *ngIf="rightsholders.length === 0">
                        <div colspan="4" style="text-align: center;">
                            No labels found
                        </div>
                    </div>
                </div>
                <div class="df">
                    <div class="data">
                        <h5>Labels: <span>{{ rightsholderBoardsTotal | number : "" : "es"}}</span></h5>
                    </div>
                    <div class="pagination">
                        <button class="btn"
                            [ngClass]="{'white': rightsholderBoardsPageIndex > 0, 'disabled': rightsholderBoardsPageIndex === 0}"
                            (click)="previousPage()">
                            <img [src]="rightsholderBoardsPageIndex > 0 ? 'assets/icons/arrow-left.svg' : 'assets/icons/arrow-left-white.svg'"
                                alt="Go to previous page" />Previous
                        </button>

                        <ng-container *ngFor="let page of getPageNumbers()">
                            <button class="btn"
                                [ngClass]="{'green': rightsholderBoardsPageIndex === page, 'white': rightsholderBoardsPageIndex !== page}"
                                (click)="goToPage(page)">
                                {{ page + 1 }}
                            </button>
                        </ng-container>

                        <button class="btn" [ngClass]="{'white': hasNextPage(), 'disabled': !hasNextPage()}"
                            (click)="nextPage()">
                            Next
                            <img [src]="hasNextPage() ? 'assets/icons/arrow-right.svg' : 'assets/icons/arrow-right-white.svg'"
                                alt="Go to next page" />
                        </button>

                        <div class="goto">
                            <h5>Jump to page</h5>
                            <div class="a">
                                <input type="number" [(ngModel)]="jumpToPageNum" min="1" [max]="getTotalPages()" />
                                <button class="btn green" (click)="jumpToPage()">
                                    <img src="assets/icons/arrow-right-white.svg" alt="Go to page" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="perpage">
                        <h5>Show up to:</h5>
                        <select [(ngModel)]="rightsholderBoardsPageSize" (change)="onPageSizeChange()">
                            <option [ngValue]="10">10</option>
                            <option [ngValue]="50">50</option>
                            <option [ngValue]="100">100</option>
                            <option [ngValue]="500">500</option>
                            <option [ngValue]="1000">1000</option>
                        </select>
                        <h5>
                            <span>labels</span>
                        </h5>
                    </div>
                </div>
            </div>
        </section>
    </main>
</div>

<div class="modal" [ngClass]="{'show': showDeleteLabelDialog}" id="deleteLabelModal">
    <div class="mw simple">
        <div class="mwrap">
            <div class="mc">
                <h2>Delete label</h2>
                <p>Are you sure you want to delete {{ selectedLabelName }}? This action cannot be undone.</p>
                <div class="actions">
                    <button class="btn white" (click)="cancelDelete()">Cancel</button>
                    <button class="btn red" (click)="confirmDelete()">Delete</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal" [ngClass]="{'show': showAddLabelDialog}" id="addLabelModal"
    (click)="closeModalOnBackgroundClick($event)">
    <div class="mw defaultmodal">
        <div class="mwrap">
            <div class="topbar">
                <span>
                    <h3>Add new label</h3>
                    <p>Set name and potential parent label.</p>
                </span>

                <img data-action="closeuserinvite" src="assets/icons/x.svg" alt="Close" (click)="closeAddLabelModal()">
            </div>
            <div class="mc">
                <!-- Add form element and formGroup directive -->
                <form [formGroup]="labelForm">
                    <div class="row">
                        <div class="inputs">
                            <div class="input">
                                <label for="name">Name of label</label>
                                <input id="name" formControlName="name" type="text" autofocus />
                            </div>
                            <div class="input">
                                <label for="parentLabel">Select parent label (optional)</label>
                                <input type="text" id="parentLabel" list="labelselection" formControlName="parentLabel"
                                    placeholder="Start typing to search..." autocomplete="off">

                                <datalist id="labelselection">
                                    <option value="" selected>No parent</option>
                                    <option *ngFor="let parent of parentLabels" [attr.data-value]="parent.boardId">{{
                                        parent.rightsholderName }}
                                    </option>
                                </datalist>
                                <span id="parentLabelError" class="error-message" 
                                    *ngIf="labelForm.get('parentLabel')?.invalid && labelForm.get('parentLabel')?.touched">
                                    Please select a valid label from the list
                                </span>
                                <!-- <select id="parentLabel" formControlName="parentLabel">
                                    <option value="" selected>No parent</option>
                                    <option *ngFor="let parent of parentLabels" [value]="parent.boardId">{{ parent.rightsholderName }}
                                    </option>
                                </select> -->
                            </div>

                            <div *ngIf="isValidParentLabel()" class="input">
                                <div class="t-c collecttoggle">
                                    <div class="toggle-row">
                                        <div class="toggle-switch">
                                            <input type="checkbox" id="isCollectingForItself"
                                                formControlName="isCollectingForItself" 
                                                name="isCollectingForItself" 
                                                [checked]="isCollectingForItself"
                                                (change)="toggleCollectingForItself()"/>
                                            <span class="ts" (click)="toggleCollectingForItself()"></span>
                                        </div>
                                        <label class="" for="isCollectingForItself">Collect for themselves</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <hr class="dashed" />
                <button class="btn green" (click)="createLabel()" [disabled]="!labelForm.valid || isCreatingLabel">
                    {{ isCreatingLabel ? 'Loading' : 'Create label and go to settings' }}
                </button>
            </div>
        </div>
    </div>
</div>